import type { EntitiesState } from '@redux/entities'

type FilterUnselectedEntitiesParams = {
  entities: EntitiesState,
  entityKey: string,
  entityIds: number[],
}

function filterUnselectedEntities(params: FilterUnselectedEntitiesParams) {
  const { entities, entityKey, entityIds = [] } = params
  // @ts-expect-error TS7053
  const entitiesToFilter = entities[entityKey] || {}

  // @ts-expect-error TS18046
  const filteredEntities = Object.values(entitiesToFilter).filter(entity => !entityIds.includes(entity.id))

  return filteredEntities
}

export default filterUnselectedEntities
